import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitLead = (payload) => apiClient.post("/leads", payload).then((r) => r.data);
export const submitChat = (payload) => apiClient.post("/chat-messages", payload).then((r) => r.data);
export const submitContact = (payload) => apiClient.post("/contact", payload).then((r) => r.data);
